import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class DatabaseInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let requestUrl = request.urlWithParams;

    // skip if database is already appended or assets are requested
    if (!/database=/.test(requestUrl) && !/assets/.test(requestUrl)) {
      // check if other params are present to determine if it is the first or not (/? vs /?any&)
      requestUrl = `${requestUrl}${/\/\?/.test(requestUrl) ? '&' : '?'}database=default`;
    }

    request = request.clone({
      url: requestUrl,
      setHeaders: { Platform: 'PatientLynk' }
    });

    return next.handle(request);
  }
}
